export const getProductLink = (product) => (product?.link || '').trim();

export const normalizeProductLink = (rawLink) => {
  const link = (rawLink || '').trim();
  if (!link || link === '#') {
    return '';
  }
  if (/^https?:\/\//i.test(link)) {
    return link;
  }
  return `https://${link}`;
};

export const hasProductLink = (productOrLink) => {
  if (typeof productOrLink === 'string') {
    return Boolean(normalizeProductLink(productOrLink));
  }
  return Boolean(normalizeProductLink(getProductLink(productOrLink)));
};

export const openProductLink = (product) => {
  const link = normalizeProductLink(getProductLink(product));
  if (link) {
    window.open(link, '_blank', 'noopener,noreferrer');
  }
};
